import React from 'react'
import { Link } from 'react-router-dom'
import { IconMenu2, IconLogout } from '@tabler/icons-react'

export default function Header({ sidebarToggle, isActive }) {
  const UserName = localStorage.getItem('UserName')

  const handleLogout = () => {
    localStorage.clear()
  }

  return (
    <div className="p-10 flex items-center justify-between md:static relative">
      <div className="max-w-[250px] w-full flex items-center gap-10">
        <button
          aria-label="hamburger icon"
          onClick={sidebarToggle}
          className={`xl:hidden xl:after:hidden after:contents-[] after:fixed after:z-[4] after:w-full after:h-full after:left-0 after:top-0 after:bg-bg-transparent after:backdrop-blur-[5px] after:transition-all after:duration-500 after:ease-in-out ${
            isActive
              ? 'after:opacity-100 after:visible after:overflow-auto'
              : 'after:opacity-0 after:invisible after:overflow-hidden'
          }`}
        >
          <IconMenu2 />
        </button>
        <Link to="/" className="flex-1">
         <h1 className="w-full text-2xl font-semibold whitespace-nowrap overflow-hidden text-ellipsis">
  {`Welcome ${UserName || 'Guest'}, to the HRMS Portal`}
</h1>


        </Link>
      </div>

      <div className="flex-1 flex items-center justify-end gap-15 px-10">
        <Link aria-label="logout" to="/login">
          <IconLogout
            onClick={handleLogout}
            className="w-[22px] h-[22px] stroke-[1.5] text-text-primary transition-all duration-300 hover:text-primary"
          />
        </Link>
      </div>
    </div>
  )
}
